import React from 'react';
import { makeStyles } from '@material-ui/core';

import { useLocation } from 'ha/helpers/router';
import Grid from 'ha/ui/next/Grid';
import units from 'ha/theme/units';
import { NormalizedListing } from 'ha/modules/Algolia/Types';
import { normalizeAlgoliaListing } from 'ha/components/next/ListingCard/utils/normalizeAlgoliaListing';
import SearchResultsBottom from './SearchResultsBottom';
import SearchResultsEmpty from './SearchResultsEmpty';
import ListingPreviewCardTracked from '../containers/ListingPreviewCardTracked';
import SearchUrgencyCard from './SearchUrgencyCard';

interface Props {
  items: NormalizedListing[];
  cityCanonical?: string;
  countryCanonical?: string;
  countryCode?: string;
  shouldShowCitiesNearby: boolean;
  onHighlight: (id: number) => void;
  onUnhighlight: (id: number) => void;
  cityLocalizedName?: string;
  countryLocalizedName?: string;
  trackSearchResults: (items: NormalizedListing[]) => void;
}

const useStyles = makeStyles(theme => ({
  seoMargin: {
    margin: units.yx(0.75, 0),
  },
  scrollWrapper: {
    flexGrow: 1,
    padding: units.yx(0, 1.5),
    [theme.breakpoints.down('md')]: {
      padding: units.yx(0, 0.7),
    },
  },
}));

export const SearchResults: React.FC<Props> = ({
  items,
  onHighlight,
  onUnhighlight,
  shouldShowCitiesNearby,
  cityCanonical,
  countryCanonical,
  countryCode,
  cityLocalizedName,
  countryLocalizedName = '',
  trackSearchResults,
}) => {
  const classes = useStyles();
  const {
    query: { startDate, endDate },
  } = useLocation();

  React.useEffect(() => {
    trackSearchResults(items);
  }, []);

  return (
    <div className={classes.scrollWrapper}>
      {items.length > 0 ? (
        <React.Fragment>
          {startDate && endDate && <SearchUrgencyCard />}
          <Grid container spacing={3}>
            {items.map((room, index) => (
              <Grid item xs={12} sm={12} md={6} key={room.id}>
                <ListingPreviewCardTracked
                  listingId={room.id}
                  room={normalizeAlgoliaListing(room)}
                  onMouseEnter={onHighlight}
                  onMouseLeave={onUnhighlight}
                  isLazy={index >= 4}
                  withGallery
                  withFavorites
                  trackLocation="search"
                />
              </Grid>
            ))}
          </Grid>
        </React.Fragment>
      ) : (
        <SearchResultsEmpty />
      )}
      <SearchResultsBottom
        cityCanonical={cityCanonical}
        countryCanonical={countryCanonical}
        countryCode={countryCode}
        cityLocalizedName={cityLocalizedName}
        countryLocalizedName={countryLocalizedName}
        shouldShowCitiesNearby={shouldShowCitiesNearby}
      />
    </div>
  );
};

export default SearchResults;
